<template>
    <div class="form-group" :class="formGroupClass" v-if="page === 'modal'">
        <label :class="recommendation ? 'text-left d-block mb-2 mb-lg-0' : ''">{{ label }}</label>
        <small class="text-muted font-italic">{{ recommendation }}</small>
        <app-input
            :type="type"
            :model-value="model"
            @update:model-value="handleInput"
            v-bind="$attrs"
            :error-message="errorMessage"
            :label="fileLabel"
            :id="fieldId"
            autocomplete="false"
        />
        <slot name="suggestion"></slot>
    </div>
    <div class="form-group" :class="formGroupClass" v-else-if="page === 'page'">
        <div :class="`row ${ labelAlignment === 'center' ? 'align-items-center' : ''}`">
            <div class="col-lg-3 col-xl-3 col-md-3 col-sm-12">
                <label class="text-left d-block mb-lg-0">
                    {{ label }} <br v-if="recommendation"/>
                    <small v-if="recommendation" class="text-muted font-italic">
                        {{ recommendation }}
                    </small>
                </label>
            </div>
            <div class="col-lg-8 col-xl-8 col-md-8 col-sm-12">
                <app-input
                    :type="type"
                    :model-value="model"
                    @update:model-value="handleInput"
                    v-bind="$attrs"
                    :error-message="errorMessage"
                    :label="fileLabel"
                    :id="fieldId"
                    autocomplete="false"
                />
                <slot name="suggestion"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import {FormMixin} from "../../../core/mixins/form/FormMixin";

export default {
    name: "FormGroup",
    mixins: [FormMixin],
    inheritAttrs: false,
    emits: ['input', 'update:modelValue'],
    props: {
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            required: true
        },
        value: {
            default: undefined
        },
        // Vue 3 v-model
        modelValue: {
            default: undefined
        },
        page: {
            default: 'modal'
        },
        errorMessage: {
            type: String,
            default: ""
        },
        recommendation: {},
        fileLabel: {},
        formGroupClass: {
            type: String
        },
        id: {
            type: String,
            default: ''
        },
        labelAlignment: {
            type: String,
            default: 'center'
        }
    },
    data() {
        return {
            model: '',
            modelName: ''
        }
    },
    computed: {
        // Stable, unique id/field key (Vue 3 has no v-model expression to read).
        fieldId() {
            if (this.id) return this.id;
            const uid = this.$ && this.$.uid !== undefined ? this.$.uid : Math.random().toString(36).slice(2);
            return 'form_group_' + uid;
        }
    },
    methods: {
        // Child app-input updated: sync local model and propagate both the
        // Vue 3 (update:modelValue) and legacy (input) events to the parent.
        handleInput(value) {
            this.model = value;
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
        }
    },
    watch: {
        value: {
            handler: function (value) {
                if (value !== undefined) this.model = value;
            },
            immediate: true
        },
        modelValue: {
            handler: function (value) {
                if (value !== undefined) this.model = value;
            },
            immediate: true
        },
        errorMessage: {
            handler: function (errorMessage) {
                if (errorMessage) {
                    this.fieldStatus.isSubmit = true
                }
            },
            immediate: true
        }
    },
}
</script>
